<template>
  <div class="settings-container step-three">
    <div v-if="retailerTipsTotal" class="tips-wrapper">
      <retailer-tips
          :selectedRetailers="selectedRetailers"
          :retailerTipsTotal="retailerTipsTotal">
      </retailer-tips>
    </div>
    <div class="name-wrapper">
      <label>name this image</label>
      <input
          id="ad_name"
          name="ad_name"
          v-model="adName"
          type="text"
          maxlength="50"
          @change="validateName" >
      <small class="max-character">50 characters max</small>
    </div>
    <add-image
        :adImage="adImage"
        :adId="ad.id"
        :imageLoading.sync="imageLoading"
        :currentAdvertiserId="currentAdvertiserId"
        :isEdit="isEdit"
        ref="addImage"
        @loadAd="$emit('loadAd')"
        @uploadImage="updateAd"
        @setPageErrors="setErrors">
    </add-image>
    <div class="suggested_text_wrapper">
      <toggle-section-slide
          key="suggested_text"
          :shouldOpen="showSuggestedTextField"
          toggleText="suggest text"
          toggleTextClasses="text-link"
          @onToggleTextClick="showSuggestedTextField = !showSuggestedTextField">

          <textarea
            id="ad_suggested_text"
            name="ad_suggested_text"
            slot="mainContent"
            rows="8"
            cols="40"
            v-model="suggestedText"
            style="resize: none"
            :maxlength="characterLimit"
            :placeholder="suggestedTextPlaceholder"
            @focus="hidePlaceholder"
            @blur="showPlaceholder" />
          <div slot="extraContent" class="characterCount">
            {{suggestedText.length}}/{{characterLimit}}
          </div>
      </toggle-section-slide>
    </div>
  </div>
</template>

<script>
  import AddImage from './AddImage'
  import emojiRegex from 'emoji-regex/RGI_Emoji.js'
  import RetailerTips from './RetailerTips.vue'
  import ToggleSectionSlide from '../Shared/ToggleSectionSlide'

  export default {
    props: {
      ad: Object,
      currentAdvertiserId: [Number, String],
      imageLoading: Boolean,
      isEdit: Boolean,
      selectedRetailers: Array,
    },

    name: 'StepThree',

    components: {
      AddImage,
      RetailerTips,
      ToggleSectionSlide
    },

    data() {
      return {
        adImage: null,
        adName: null,
        characterLimit: 300,
        placeholder: "enter in text that will be suggested for the retailer to include in the campaign stashboard with your ad image (optional)",
        showSuggestedTextField: false,
        suggestedText: "",
        suggestedTextPlaceholder: ""
      }
    },

    created() {
      if (this.ad) this.setValues()
    },

    methods: {
      hidePlaceholder(){
        this.suggestedTextPlaceholder = ""
      },

      imageLoadingErrorHandler() {
        this.$refs.addImage.clearImage()
      },

      setData(field, value) {
        const dataToUpdate = { [field]: value }
        this.updateAd(dataToUpdate)
      },

      setErrors(errorKey, message) {
        this.$emit('setPageErrors', errorKey, message)
      },

      setValues() {
        this.adImage = this.ad.attachments[0]
        this.adName = this.ad.name
        this.suggestedText = this.ad.suggested_text || ""
        this.showSuggestedTextField = this.suggestedText.length > 0
        this.suggestedTextPlaceholder = this.placeholder
      },

      showPlaceholder(){
        this.suggestedTextPlaceholder = this.placeholder
        this.setData('suggested_text', this.suggestedText)
      },

      updateAd(dataToUpdate, additionalParams, isForCompletion) {
        this.$emit('updateAd', dataToUpdate, additionalParams, isForCompletion)
      },

      validateName() {
        const isValid = !!this.adName,
              errorMessage = isValid ? '' : 'must enter a name'

        this.setErrors('adName', errorMessage)
        this.setData('name', this.adName)
      },

      validateImage() {
        this.$refs?.addImage?.validateImage()
      }
    },

    watch: {
      ad: function () {
        this.setValues()
      },
      suggestedText: function() {
        this.suggestedText = this.suggestedText.replace(emojiRegex(), "")
      }
    },

    computed: {
      retailerTipsTotal: function () {
        if (this.selectedRetailers) {
          const clearEmptyTipFields = this.selectedRetailers.filter((retailer) => retailer.ads_image_preferences),
              total = clearEmptyTipFields.map(obj => obj.ads_image_preferences)
          return total.length
        }
      }
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.step-three
  .name-wrapper
    margin-bottom: 1.25rem

    &.disabled
      opacity: .5

    label
      display: block
      margin: .25rem

    input
      margin-bottom: .4rem
      width: unset

    .max-character
      display: block
      color: $negative-color

  .tips-wrapper
    position: absolute
    right: 0
    top: 0
    width: 350px

  .suggested_text_wrapper
    .slide-section
      .slide-section__slider
        &.slide-down
          max-height: 250px
          padding-bottom: 20px

        textarea
          margin-bottom: 0
          border-radius: 10px
          outline: none

        .characterCount
          width: 450px
          text-align: right
          margin: auto
</style>
